import React, { useState, useEffect } from "react";
import { Col, Image, Row, Card } from "react-bootstrap";
import { IPUrl } from "../../commons/IPAddress";
import { useParams } from "react-router-dom";
import Media from "../../components/Media";
import AllHeader from "../../components/AllHeader";
import Parent from "../../container/Parent";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";

function InternalCelebrities() {
  const params = useParams();
  const [seenFile, setSeenFile] = useState([]);
  const [Id, setId] = useState(params.requestId);


  useEffect(() => {
    axiosInstance.post("GetCelebrit", {
      Id: Id,
    })
      .then((res) => {
        if (res.data.result === "true") {
          setSeenFile(res.data.data)
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  }, [Id]);

  return (
    <div className="pt-2">
      <AllHeader>
        <span>مشاهیر </span>
      </AllHeader>
      <Parent>
        {seenFile.map((data, index) => {
          return (
            <Col xs={12} key={index}>
              <div className="rgc-internal-news">
                <Row>
                  <Col xs={12} className="rgc-celeb p-4">

                    <Image
                      src={IPUrl + "/UploadedFile/Celebret/Ssn/" + data.Pic}
                      className="img-fluid m-0 col-12 col-md-5 float-none float-md-start"
                    />

                    <Card.Title>
                      {data.Tittle}
                    </Card.Title>
                    <p>
                      <i className="fas fa-book-reader rgc-text-icon" aria-hidden="true"></i>
                      {data.Field}
                    </p>


                    <Card.Text className="rgc-txt-celeb" dangerouslySetInnerHTML={{
                      __html: decodeURIComponent(data.Text)
                        .replaceAll("/Content/UserFiles/", `${IPUrl}/Content/UserFiles/`)
                    }}>
                    </Card.Text>

                    {/* social media */}
                    <hr />
                    <div className="rgc-media-style">
                      <Media address={`/Internalcelebrities/${Id}`} title={data.Tittle} />
                      <span> اشتراک گذاری</span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          )
        })
        }
      </Parent>
    </div>
  );
}

export default InternalCelebrities;
